import React, { useEffect, useRef, useState } from 'react';
import video from '../../assets/videos/demo.mp4';
import { motion } from 'framer-motion'
import { FaPlay, FaPause } from "react-icons/fa";
import { useLanguage } from '../../store/languageContext';
const VideoSection = () => {
    const videoRef = useRef(null);
    const cursorRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const sectionRef = useRef(null);
    const { setNavColor } = useLanguage();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('black');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);
    const handleMouseEnter = () => {
        if (cursorRef.current && window.innerWidth >= 768) {
            cursorRef.current.style.display = 'flex';
        }
    };

    const handleMouseLeave = () => {
        if (cursorRef.current) {
            cursorRef.current.style.display = 'none';
        }
    };

    const handleMouseMove = (e) => {
        if (cursorRef.current && window.innerWidth >= 768) {
            cursorRef.current.style.left = `${e.clientX}px`;
            cursorRef.current.style.top = `${e.clientY}px`;
        }
    };

    const handleClick = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
                setIsPlaying(false);
            } else {
                videoRef.current.play();
                setIsPlaying(true);
            }
        }
    };

    return (
        <>
            <section
                className="landing-section container mx-auto flex justify-center items-center pb-8 sm:pb-[50px] relative h-[50vh] sm:h-[60vh] md:h-[calc(100vh-100px)] px-4 sm:px-6"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onMouseMove={handleMouseMove}
                onClick={handleClick}
                ref={sectionRef}
            >
                <motion.video
                    initial={{ y: 100, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.3, delay: 0.2, ease: 'easeOut' }}
                    viewport={{ once: true }}
                    ref={videoRef}
                    muted
                    playsInline
                    className="w-full h-full object-cover cursor-pointer md:cursor-none rounded-[20px] sm:rounded-[30px] md:rounded-[50px] shadow-lg"
                >
                    <source src={video} type="video/mp4" />
                    Your browser does not support the video tag.
                </motion.video>
                <div className="absolute inset-0 flex items-center justify-center md:hidden pointer-events-none">
                    <div className="w-14 h-14 rounded-full bg-white/50 backdrop-blur-md flex items-center justify-center text-white border border-white">
                        {isPlaying ? <FaPause /> : <FaPlay />}
                    </div>
                </div>
            </section>
            <motion.div
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ duration: 0.5 }}
                ref={cursorRef}
                className="fixed pointer-events-none z-50 w-[50px] h-[50px] sm:w-[60px] sm:h-[60px] rounded-full bg-white/50 backdrop-blur-md hidden md:flex items-center justify-center text-white text-sm border border-white font-semibold transform -translate-x-1/2 -translate-y-1/2"
            >
                {isPlaying ? <FaPause /> : <FaPlay />}
            </motion.div>
        </>
    );
};

export { VideoSection };